module.exports = __webpack_public_path__ + "static/30-9d8e4694ecbb528bc863260590fc3e4b.jpg";